

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Company, Pro, ProSearchRequest, PagedResult } from '@shared/models';
	import ProItem from '@client/views/industry/pros/ProItem.vue';

	@Component({
		components: {
			ProItem,
		},
	})
	export default class CompanyPros extends BaseView {


		public modelId: string;

		public list: PagedResult<Pro> = new PagedResult<Pro>();
		public criteria: ProSearchRequest = new ProSearchRequest({ pageIndex: 0, pageSize: 32, sortBy: 'displayname', sortDirection: 'asc' });

		public async mounted() {
			await this.refresh();
		}

		public async refresh() {
			this.loading = true;
			try {
				this.modelId = this.$route.params.id;
				this.criteria.companyIds.push(this.modelId);
				this.list = await this.$api.proService.search(this.criteria);
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading this companies professional skateboarder list');
			} finally {
				this.loading = false;
			}
		}

		/** Fires when the page is changed */
		public pageChanged(page: number) {
			this.criteria.pageIndex = (page - 1);
			this.refresh();
		}


	}

